<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import "@/assets/styles/reset.scss";

export default {
  name: 'App'
}
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
